import UserFeatures from './userFeatures';

export default UserFeatures;
